export function iconeTipoEvento(tipoEvento: string): string {
  if (tipoEvento === "Audiência Pública") {
    return "pi-users";
  }
  if (tipoEvento === "Tomada de Subsídios") {
    return "pi-inbox";
  }
  if (tipoEvento === "Reunião Participativa") {
    return "pi-comments";
  }
  if (tipoEvento === "Consulta Interna") {
    return "pi-lock";
  }
  return "pi-search";
}

export function classeSituacao(situacao: string): string {
  const s = (situacao || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (s.includes("encerr")) {
    return "encerrado";
  }
  if (s.includes("inativ") || s.includes("despublic")) {
    return "inativo";
  }
  if (s.includes("cadastr")) {
    return "cadastrado";
  }
  if (s.includes("abert") || s.includes("prorrog") || s.includes("reabert") || s.includes("ativo")) {
    return "aberto";
  }
  return "padrao";
}

export function textoObjeto(html: string): string {
  if (!html) {
    return "";
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}

export function diasRestantes(periodoValidade: string): number | null {
  if (!periodoValidade) {
    return null;
  }
  const match = String(periodoValidade).match(
    /(\d{2})\/(\d{2})\/(\d{4})\s*a\s*(\d{2})\/(\d{2})\/(\d{4})/i
  );
  if (!match) {
    return null;
  }
  const fim = new Date(Number(match[6]), Number(match[5]) - 1, Number(match[4]));
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  fim.setHours(0, 0, 0, 0);
  return Math.round((fim.getTime() - hoje.getTime()) / 86400000);
}

export function textoDiasRestantes(periodoValidade: string, situacao: string): string | null {
  const dias = diasRestantes(periodoValidade);
  if (dias == null) {
    return null;
  }
  const classe = classeSituacao(situacao);
  if (classe === "encerrado" || classe === "inativo") {
    return null;
  }
  if (dias < 0) {
    return "Prazo encerrado";
  }
  if (dias === 0) {
    return "Encerra hoje";
  }
  if (dias === 1) {
    return "Resta 1 dia";
  }
  return `Restam ${dias} dias`;
}
